import { createTheme } from '@one-thd/sui-atomic-components';

const HouseStyleLightWarmTan = createTheme({
  palette: {
    mode: 'light',
    background: {
      primary: 'brand'
    }
  }
});

HouseStyleLightWarmTan.palette['--sui-palette-background-primary'] = '249 147 84';

export { HouseStyleLightWarmTan };